module.exports = __webpack_public_path__ + "img/portrait-104.dea38e06.jpg";